module.exports = __webpack_public_path__ + "static/media/NightLight.e4c83d46.logo";